import { clsx } from 'clsx';

import { QuestionMarkIcon } from '@/components/icons/input';

import cn from './styles.module.sass';

interface ITooltipProps {
    text?: string;
    className?: string;
}

export const Tooltip = ({ text, className }: ITooltipProps) => {
    return (
        <div className={clsx(cn.tooltip, className)}>
            <div className={cn.tooltipHead}>
                <span className={cn.tooltipIcon}>{QuestionMarkIcon}</span>
                <span className={cn.tooltipTitle}>Подсказка:</span>
            </div>
            <p className={cn.tooltipText}>{text}</p>
        </div>
    );
};
